module.exports = __webpack_public_path__ + "static/media/se.9679c89b.svg";